/**
 * Organization Switch Component
 * ACC-010: Multi-company access switching
 */

import { Component, OnInit, OnDestroy } from '@angular/core';
import { ApiService } from 'src/app/shared/services/api.service';
import { SubscriptionAccessService } from 'src/app/shared/services/subscription-access.service';
import { UserService } from 'src/app/shared/services/user-services/user.service';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-organization-switch',
  templateUrl: './organization-switch.component.html',
  styleUrls: ['./organization-switch.component.css']
})
export class OrganizationSwitchComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();

  organizations: any[] = [];
  currentOrgId: number | null = null;
  loading = false;

  constructor(
    private apiService: ApiService,
    private subscriptionAccessService: SubscriptionAccessService,
    private userService: UserService,
    private router: Router
  ) {
    const userData = localStorage.getItem('user');
    if (userData) {
      try {
        const user = JSON.parse(userData);
        this.currentOrgId = user.user?.org_id || null;
      } catch (e) {
        console.error('Error parsing user data:', e);
      }
    }
  }

  ngOnInit(): void {
    this.loadOrganizations();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  loadOrganizations(): void {
    this.loading = true;
    this.apiService.getOrganizationsForSwitch()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res: any) => {
          if (res.success) {
            this.organizations = res.data;
          }
          this.loading = false;
        },
        error: (err) => {
          console.error('Error loading organizations:', err);
          this.loading = false;
        }
      });
  }

  switchOrganization(orgId: number): void {
    if (orgId === this.currentOrgId) {
      return; // Already on this organization
    }

    // ACC-010: Switch organization and refresh access
    this.subscriptionAccessService.switchOrganization(orgId);

    // Update user session with new org
    const userData = localStorage.getItem('user');
    if (userData) {
      try {
        const user = JSON.parse(userData);
        user.user.org_id = orgId;
        localStorage.setItem('user', JSON.stringify(user));
        this.currentOrgId = orgId;

        // Reload page to refresh all data
        window.location.reload();
      } catch (e) {
        console.error('Error updating user data:', e);
      }
    }
  }
}
